<!-- Alert -->
@if (alert.message) {
    <fuse-alert
        class="twofa-form-fuse-alert"
        [appearance]="'outline'"
        [showIcon]="false"
        [type]="alert.type">
        {{ alert.message }}
    </fuse-alert>
}

<!-- 2fa code -->
<form
    class="auth-form-wrapper-shallow twofa-form"
    [formGroup]="signInTwoFactorForm"
    #signInTwoFactorNgForm="ngForm">
    <div class="twofa-form-code-input-container">
        <mat-form-field
            class="auth-form-field twofa-form-code-field fuse-mat-dense fuse-mat-no-subscript">
            <input
                #twoFactorCode
                matInput
                inputmode="numeric"
                [autocomplete]="'off'"
                [placeholder]="'Code'"
                [formControlName]="'twoFactorCode'" />
        </mat-form-field>
    </div>

    <!-- Activity timer: starts when username/password have values -->
    <activity-timer
        [watchedValue]="activityWatchedValue"
        [startImmediately]="true"
        [ignoreChanges]="true"
        [timeoutSeconds]="120"
        (timedOut)="onActivityTimedOut()"></activity-timer>

    <!-- Verification button -->
    <div class="auth-form-button-container twofa-form-button-container">
        <button
            mat-flat-button
            [disabled]="!signInTwoFactorForm.get('twoFactorCode')?.value"
            color="primary"
            class="auth-form-button twofa-form-verify-button"
            (click)="verifyTwoFactorCode()"
        >
            <mat-icon
                class="auth-form-field-icon twofa-form-verify-icon"
                [fontIcon]="'lock_open'"
            ></mat-icon>
            <span class="iapply-button-text twofa-form-button-text">Verify</span>
        </button>
    </div>
</form>
